import React, { useEffect, useState } from "react";

import {
  Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    TextField,
    Typography
} from "@material-ui/core";
import { SIREN_CONFIG  } from "config.js";
import moment from 'moment';

/**
 * 센서의 현재 상태 정보를 표시
 * @param {*} props 
 * @returns 
 */
export const DeviceStatusTable = props => {
  const { className, deviceId, ...rest} = props;


  const [deviceStatus, setDeviceStatus] = useState({});


  async function loadDeviceStatus() {

    var url = `${SIREN_CONFIG.HOSTNAME}/device/deviceStatus?deviceId=${deviceId}`;
    const opt = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };


    let response = await fetch(url, opt);
    let responseData = await response.json();

    responseData.resultData.map(function (row) {
      setDeviceStatus(row);
    });

  }


  useEffect(() => {

    loadDeviceStatus();

  }, []);


  return (

    <div style={{width:'100%',
    // marginTop:"30px",
    marginLeft:"60px",
    marginRight:"60px",
    marginBottom:"40px",
        alignItems: 'center', justify:"center"}}>

      <Table >
        <TableHead>
          <TableRow>
            <TableCell width="10%" align="center">status</TableCell>
            <TableCell width="5%" align="center">temp</TableCell>
            <TableCell width="15%" align="center">timestamp</TableCell>
            <TableCell width="15%" align="center">upTime</TableCell>
            <TableCell width="5%" align="center">ssid</TableCell>
            <TableCell width="5%" align="center">rssi</TableCell>
            <TableCell width="10%" align="center">serialProduct</TableCell>
            <TableCell width="10%" align="center">serialRadar</TableCell>
            <TableCell width="5%" align="center">ver</TableCell>
            <TableCell width="10%" align="center">mac</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          <TableRow>
            <TableCell width="10%" align="center"><Typography variant="body2">{deviceStatus.status}</Typography> </TableCell>
            <TableCell width="5%" align="center"><Typography variant="body2">{deviceStatus.temperature}</Typography></TableCell>
            <TableCell width="15%" align="center"><Typography variant="body2">{moment(deviceStatus.timestamp).format('YY.MM.DD HH:mm')}</Typography></TableCell>
            <TableCell width="15%" align="center"><Typography variant="body2">{moment(deviceStatus.upTime).format('YY.MM.DD HH:mm')}</Typography></TableCell>
            <TableCell width="5%" align="center"><Typography variant="body2">{deviceStatus.wifiState_ssid}</Typography></TableCell>
            <TableCell width="5%" align="center"><Typography variant="body2">{deviceStatus.wifiState_rssi}</Typography></TableCell>
            <TableCell width="10%" align="center"><Typography variant="body2">{deviceStatus.serialProduct}</Typography></TableCell>
            <TableCell width="10%" align="center"><Typography variant="body2">{deviceStatus.serialRadar}</Typography></TableCell>
            <TableCell width="5%" align="center"><Typography variant="body2">{deviceStatus.versionCode}</Typography></TableCell>
            <TableCell width="10%" align="center"><Typography variant="body2">{deviceStatus.wifiMac}</Typography></TableCell>
          </TableRow>

        </TableBody>

      </Table>
    </div>
  )
}

// export default DeviceStatusTable;

